
import {Component, NgZone, ViewChild,ElementRef, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReglaBase } from 'app/main/models/regla-base.model';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import { UtilsService } from 'app/main/services/utils.service';
import { AppConfig } from 'app/app-config';

@Component({
  selector: 'app-dialog-match-detail',
  templateUrl: './dialog-match-detail.component.html',
  styleUrls: ['./dialog-match-detail.component.scss']
})
export class DialogBoxMatchDetailCumplimiento {

  displayedColumns: string[] = ['evaluacion','control','valor','resultado'];
  displayedColumnsMatchs: string[] = ['palabra','valor','clave'];
  action: string;
  dataSource: any[] = [];
  reglaBase: ReglaBase = null;
  evaluaciones: Evaluacion[] = [];
  fecha: Date = new Date();
  disabled : boolean = false;
  organizacion: string = "";
  LOCAL_DATA: any;

  constructor(
    private _ngZone: NgZone,
    public dialogRef: MatDialogRef<DialogBoxMatchDetailCumplimiento>,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private utils: UtilsService,
    private appConfig:AppConfig,
    //private _fuseProgressBarService: FuseProgressBarService,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.organizacion = appConfig.cliente;

    this.LOCAL_DATA = {...data};
    
    this.LOCAL_DATA.cumplimiento.forEach(cumplimiento => {
        cumplimiento.matchs = this.generateArrayCumplimiento(cumplimiento.resultado);
    });
    

    
  }

  generateArrayCumplimiento(data):any[]{
    var results = [];
    if(data!= undefined && data !=""){
      var dataJson = JSON.parse(data);
      for (let key in dataJson["matchs"]) {

          var result = {palabra: key,
                        clave: dataJson["matchs"][key]["calve"],
                        valor: dataJson["matchs"][key]["valor"]};
          results.push(result);
      }
    }
    return results;


  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }


}
